import { useState, useEffect } from "react";

export function Header() {
  const [isOverHero, setIsOverHero] = useState(true);

  useEffect(() => {
    const heroSection = document.getElementById("hero");
    if (!heroSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // If the hero section is intersecting with the viewport, we are over it
        setIsOverHero(!!entry?.isIntersecting);
      },
      {
        // Trigger when the hero section is completely out of view (or entering view)
        // Using a negative rootMargin for the top offset if needed,
        // but default is fine since header is fixed at the top
        root: null,
        threshold: 0,
        rootMargin: "-80px 0px 0px 0px", // Offset by header height approximately
      },
    );

    observer.observe(heroSection);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`py-4 px-6 flex justify-between items-center fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isOverHero
          ? "bg-transparent text-white"
          : "bg-gray-950/85 backdrop-blur-md text-white shadow-lg"
      }`}
    >
      <div>
        <div className="font-bold uppercase text-lg tracking-wide">Johann Lochbaum</div>
        <div className="text-xs text-gray-400 font-mono mt-0.5">// Lücken schließen. Digital.</div>
      </div>

      <div className="flex gap-6 uppercase text-xs font-mono tracking-wider">
        <a href="#hero" className="hover:text-emerald-400 transition-colors">
          Home
        </a>
        <a href="#about" className="hover:text-emerald-400 transition-colors">
          About
        </a>
        <a href="#contact" className="hover:text-emerald-400 transition-colors">
          Contact
        </a>
      </div>
    </div>
  );
}
